import {Component, input} from '@angular/core';
import {BadgeComponent} from '../../../../../../../shared/components/badge/badge.component';
import {IconsComponent} from '../../../../../../../shared/components/icons/icons.component';
import {TooltipComponent} from '../../../../../../../shared/components/tooltip/tooltip.component';
import {CurrencyPipe} from '@angular/common';

@Component({
  selector: 'app-results-table-row-availability-badge-local',
  imports: [
    BadgeComponent,
    IconsComponent,
    TooltipComponent,
    CurrencyPipe
  ],
  templateUrl: './results-table-row-availability-badge-local.component.html',
  styleUrl: './results-table-row-availability-badge-local.component.css'
})
export class ResultsTableRowAvailabilityBadgeLocalComponent {
  data = input.required<any>();
  price = input.required<(cost: number) => number>();
}
